import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { QuickViewComponent } from "../../modal/quick-view/quick-view.component";
import { CartModalComponent } from "../../modal/cart-modal/cart-modal.component";
import { Product } from "../../../classes/product";
import { ProductService } from "../../../services/product.service";
import { MatDialog } from '@angular/material/dialog';
import { ExtrasDialogComponent } from '../extras-dialog/extras-dialog.component';
import { Extra } from "../../../classes/extra";

@Component({
  selector: 'app-product-box-one',
  templateUrl: './product-box-one.component.html',
  styleUrls: ['./product-box-one.component.scss']
})
export class ProductBoxOneComponent implements OnInit {

  @Input() product: Product;
  @Input() currency: any = this.productService.Currency; // Default Currency 
  @Input() thumbnail: boolean = false; // Default False 
  @Input() onHowerChangeImage: boolean = false; // Default False
  @Input() cartModal: boolean = false; // Default False
  @Input() loader: boolean = false;

  @ViewChild("quickView") QuickView: QuickViewComponent;
  @ViewChild("cartModal") CartModal: CartModalComponent;

  public ImageSrc: string

  constructor(private productService: ProductService, private dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.loader) {
      setTimeout(() => { this.loader = false; }, 200); // Skeleton Loader
    }
  }

  // Get Product Color
  Color(variants) {
    const uniqColor = [];
    for (let i = 0; i < Object.keys(variants).length; i++) {
      if (uniqColor.indexOf(variants[i].color) === -1 && variants[i].color) {
        uniqColor.push(variants[i].color)
      }
    }
    return uniqColor
  }

  // Change Variants
  ChangeVariants(color, product) {
    product.variants.map((item) => {
      if (item.color === color) {
        product.images.map((img) => {
          if (img.image_id === item.image_id) {
            this.ImageSrc = img.src;
          }
        })
      }
    })
  }

  // Change Variants Image
  ChangeVariantsImage(src) {
    this.ImageSrc = src;
  }

  addToCart(product: Product) {
    if (!!product.extras && product.extras.length > 0)
    {
      const dialogRef = this.dialog.open(ExtrasDialogComponent, {
        width: '400px',
        data: {extras: product.extras, basePrice: product.price}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });

      dialogRef.componentInstance.onExtraEvent.subscribe(extra => {
        var temp = Object.assign({}, product);
        temp.extras = new Array<Extra>(extra);
        temp.price += extra.price;
        this.productService.addToCart(temp);
        dialogRef.close();
      })
      return;
    }

    this.productService.addToCart(product);

  }

  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  addToCompare(product: any) {
    this.productService.addToCompare(product);
  }

  getProductTitle(title: string)
  {
    if (!!title)
    {
      const regex = /\*{3}/;
      const regex2 = /\*{2}/;
      const regex1 = /\*/;
      title = title.replace(regex, '<img src="assets/images/icon/chilli.svg" style="width: 18px;margin-bottom: 5px;margin-left: 5px;"><img src="assets/images/icon/chilli.svg" style="width: 18px;margin-bottom: 5px;margin-left: 5px;"><img src="assets/images/icon/chilli.svg" style="width: 18px;margin-bottom: 5px;margin-left: 5px;">');
      title = title.replace(regex2, '<img src="assets/images/icon/chilli.svg" style="width: 18px;margin-bottom: 5px;margin-left: 5px;"><img src="assets/images/icon/chilli.svg" style="width: 18px;margin-bottom: 5px;margin-left: 5px;">');
      title = title.replace(regex1, '<img src="assets/images/icon/chilli.svg" style="width: 18px;margin-bottom: 5px;margin-left: 5px;">');
      return title;
    }
    return null;
  }

}
